module.exports = __webpack_public_path__ + "img/bg (1).d2d92931.jpg";